export function getUUID(): string {
  return typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : Math.random().toString(36).substring(2, 15);
}

export function parseSlotComment(comment: string | undefined): { notes: string; notesJson: object | null } {
  if (!comment) {
    return { notes: '', notesJson: null };
  }

  try {
    const parsed = JSON.parse(comment) as unknown;
    if (parsed && typeof parsed === 'object' && 'type' in (parsed as object)) {
      return { notes: '', notesJson: parsed as object };
    }
  } catch {
    // ignore JSON parse errors
  }

  return { notes: comment, notesJson: null };
}
